import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-shrink-0 space-y-3 sm:space-x-3 sm:space-y-0 sm:flex-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Edit", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "View PDF", -1)

import PageLoader from "@/components/loaders/PageLoader.vue"
import CaseConferenceLayout from '../../Component/CaseConferenceLayout.vue';
import MinutesMeetingTab from "../../Tabs/MinutesMeetingTab.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { EyeIcon } from "@heroicons/vue/24/solid";

import { ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from "vue-router";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import PersonalInformationService from "@/classes/Cases/IntakeForms/PersonalInformationService";
import CaseConferenceService from "@/classes/Cases/CaseConference/CaseConferenceService";
import { errorResponse } from "@/helpers/errorMessage";
import { useNetworkStore } from '@/store/network';
import OfflineSyncCaseConference from "@/classes/Forms/Cases/CaseConference/OfflineSyncCaseConference";
import OfflineSyncMinutes from "@/classes/Forms/Cases/CaseConference/OfflineSyncMinutes";
import { onIonViewWillEnter } from "@ionic/vue";
import PencilUnderlineIcon from "@/components/icons/pencilUnderlineIcon.vue"; 
import OnlineSynching from "@/classes/Synching/OnlineSynching";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const loading = ref(false);
const loaded = ref(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const createMode = ref<boolean>(true);
const editMode = ref<boolean>(true);
const isView = ref(false)
const isIonWillEnter = ref<boolean>(false);

const route_params = route.params;
const errors = ref<any>();
const patient = ref<string>('');
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const caseConferenceId = ref<number | null>(route.params.caseConference);

const networkStore = useNetworkStore();

const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const onlineSync = new OnlineSynching();


const form = ref<any>({
    id: null,
    minutes: null,
    meeting_minutes: null,
    date_time: null,
    date_time_formatted: null,
})

const fetch = async ():Promise<void> => {
    loading.value = true;

    await CaseConferenceService
        .indexMinutes(
            patientId.value,
            caseId.value,
            caseConferenceId.value,
            isNetworkAvailable.value
        )
        .then(async (response: object) => {
            const item = response.data.item
            patient.value = item.patient_name;

            Object.assign(form.value, item);
            if (form.value.meeting_minutes) {
                isView.value = true
            }

            // await OfflineSyncMinutes.syncToOffline(form.value, caseId.value);
            
            loading.value = false
        })
        .catch((error: object) => { 
            console.log(error)
            errors.value = errorResponse(error.response?.data?.message);
        })
        .finally(() => loading.value = false);
	
}

const save = () => {
    loading.value = true
    showConfirmation.value = false

    if (caseId.value) {
		CaseConferenceService.storeMinutes(
			patientId.value,
			caseId.value,
            caseConferenceId.value,
            form.value,
            isNetworkAvailable.value
		)
			.then((response: object) => {
                isView.value = true
                loading.value = false
                showSuccess.value = true;
                fetch()
			})
			.catch((error: object) => { 
                console.log(error)
                loading.value = false
                showConfirmation.value = false
                errors.value = errorResponse(error.response?.data?.message);
            });
	}
}

const closeError = () => {
    errors.value = ''
}

const generatePDFAccess = ():void => {
	CaseConferenceService
		.generatePDFAccess(
			patientId.value,
			caseId.value,
			caseConferenceId.value,
            isNetworkAvailable.value
		)
		.then(({data}) => {
			if(data.token){
				downloadPDF(data.token)
			}
		}).catch((errors) => {
			console.log(errors);
		})

}
const downloadPDF = (token:string):void => {
	CaseConferenceService
		.downloadPDF(
			caseConferenceId.value,
			token,
            isNetworkAvailable.value
		)
		.then(({data}) => {
			console.log(data);
		}).catch((errors) => {
			console.log(errors);
		})

}

const redirectSuccess = (): void => {
    showSuccess.value = false;
    createMode.value = false;
    editMode.value = false;
};

onIonViewWillEnter(async () => {
    if (isIonWillEnter.value) {
        await fetch();
        await onlineSync.checkDrafts();
    }
});

onMounted(async () => {
    await fetch();   
    isIonWillEnter.value = true;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CaseConferenceLayout, { patient: patient.value }, {
    actionButtons: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!isView.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(ButtonComponent, {
                btnWidth: "quinary",
                fill: "outline",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(`/patient/${patientId.value}/cases/${caseId.value}/edit/`))),
                customClass: "quinary md:w-auto w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              }),
              _createVNode(ButtonComponent, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = showConfirmation.value = true)),
                customClass: "primary md:w-auto w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Save ")
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (isView.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(ButtonComponent, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isView.value = !isView.value)),
                customClass: "primary md:w-auto w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(PencilUnderlineIcon, { class: "object-contain w-4 h-4 mr-1 icon" }),
                  _hoisted_2
                ]),
                _: 1
              }),
              (isNetworkAvailable.value)
                ? (_openBlock(), _createBlock(ButtonComponent, {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (generatePDFAccess())),
                    customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700 md:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(EyeIcon), { class: "w-5 h-5 mr-2 -ml-1 icon" }),
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (!createMode.value && editMode.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(ButtonComponent, {
                btnWidth: "quinary",
                fill: "outline",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (editMode.value = !editMode.value)),
                customClass: "quinary md:w-auto w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              }),
              _createVNode(ButtonComponent, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = showConfirmation.value = true)),
                customClass: "primary md:w-auto w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Save Changes ")
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(MinutesMeetingTab, {
        form: form.value,
        isView: isView.value,
        "onUpdate:form": _cache[6] || (_cache[6] = (value) => form.value = value)
      }, null, 8, ["form", "isView"]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[8] || (_cache[8] = ($event: any) => (save())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Save Changes",
        content: "Are you sure do you want to save added details?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Success!",
        content: "Details has been successfully saved!"
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        onClose: closeError,
        show: errors.value?.message ? true : false,
        content: errors.value?.message
      }, null, 8, ["show", "content"])
    ]),
    _: 1
  }, 8, ["patient"]))
}
}

})